import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation, ViewRef } from '@angular/core';
import { CmsService, PaginationModel } from '@spartacus/core';
import { BREAKPOINT, BreakpointService, CmsComponentData } from '@spartacus/storefront';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Observable, Subscription } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { NewsCategoryPayload, NewsPayload, NewsService } from 'src/app/service/news/news.service';
import { SlickCarouselUtilService } from '../../../../utility/slick-carousel.util';

@Component({
  selector: 'app-news-list',
  templateUrl: './news-list.component.html',
  styleUrls: ['./news-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class NewsListComponent implements OnInit, OnDestroy {
  data$: Observable<any[]> = this.componentData.data$;
  news$: Observable<any>;
  category$: Observable<any>;
  pageStructure$: Observable<any>;
  listCategory: string;
  currPage: string;
  relatedNews: boolean;
  payload: NewsPayload = {
    category: '',
    currentPage: 0,
    fields: 'DEFAULT',
    pageSize: 9,
  };
  categoryPayload: NewsCategoryPayload = {
    newsPageId: '',
  };
  PaginationModel: PaginationModel = {
    currentPage: 0,
    pageSize: 0,
    sort: null,
    totalPages: 0,
    totalResults: 0,
  };
  slickConfig: any;
  currentLanguage: string;

  isMobile = false;
  cxMobileWidth = this.breakpointService.getSize(BREAKPOINT.sm);
  newsListSubscription: Subscription;
  reloadLanguageForNewsCategoryName$: Subscription;
  activeLanguage$: Observable<string> = this.languageService.getActive();

  constructor(
    protected componentData: CmsComponentData<any>,
    private newsService: NewsService,
    private cmsService: CmsService,
    private breakpointService: BreakpointService,
    private cdr: ChangeDetectorRef,
    private deviceService: DeviceDetectorService,
    private languageService: ShimanoLanguageService
  ) {
    this.category$ = this.cmsService.getCurrentPage();
    this.slickConfig = new SlickCarouselUtilService();
    this.setslickConfig();
  }

  slickInit(e: any) {
    // to avoid slick init error when rendered
  }

  ngOnInit() {
    this.isMobile = window.innerWidth < this.cxMobileWidth;

    this.newsListSubscription = this.cmsService
      .getCurrentPage()
      .pipe(take(1))
      .subscribe((data) => {
        if (data && data.template) {
          this.currPage = data.template;
          this.payload.category = 'ALL';
          if (this.isMobile) {
            this.payload.pageSize = 5;
          } else {
            this.payload.pageSize = 9;
          }
          this.relatedNews = false;
          if (this.currPage !== 'NewsPageTemplate') {
            this.categoryPayload.newsPageId = data.pageId;
            this.newsService
              .getNewsCategory(this.categoryPayload)
              .pipe(take(1))
              .subscribe((cat) => {
                if (Object.keys(cat).length > 0) {
                  this.listCategory = cat.code;
                  this.payload.category = this.listCategory;
                  this.relatedNews = true;
                  this.getNewsSvc(data.label);
                } else {
                  this.payload.pageSize = 4;
                }
              });
          }
          this.getNewsSvc();
        }
      });

    if (this.currPage === 'NewsPageTemplate') {
      this.newsService.categoryChange.subscribe((data) => {
        this.listCategory = data;
        this.payload.category = data;
        this.payload.currentPage = 0;
        if (this.isMobile) {
          this.payload.pageSize = 5;
        } else {
          this.payload.pageSize = 9;
        }

        this.getNewsSvc();
      });
    }
    this.reloadLanguageForNewsCategoryName$ = this.activeLanguage$.subscribe((language) => {
      if (this.currentLanguage !== language) {
        this.currentLanguage = language;
        this.getNewsSvc();
      }
    });
  }

  setslickConfig() {
    const slickObj = this.slickConfig.defaultConfig;
    slickObj.responsive = [];
    if (this.currPage === 'NewsPageTemplate') {
      slickObj.slidesToShow = 3;
      slickObj.slidesToScroll = 3;
      slickObj.responsive.push({
        breakpoint: 320,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: false,
          variableWidth: true,
        },
      });
    } else {
      slickObj.slidesToShow = 4;
      slickObj.slidesToScroll = 4;
      slickObj.responsive.push(
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            draggable: true,
            variableWidth: true,
          },
        },
        {
          breakpoint: 577,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            draggable: true,
            variableWidth: true,
          },
        },
        {
          breakpoint: 320,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            draggable: true,
            variableWidth: true,
          },
        }
      );
      if (!this.deviceService.isDesktop()) {
        slickObj.arrows = false;
      }
    }
    this.slickConfig = slickObj;
  }

  getNewsSvc(newsId = '') {
    this.news$ = this.newsService.getNews(this.payload).pipe(
      filter(Boolean),
      map((data: any) => {
        let val: any;
        let removed: any;

        if (this.currPage === 'NewsPageTemplate') {
          val = data.articles;
          this.updatePaginationModel(data);
        } else {
          let currentArticleIndex = data.articles.findIndex((x: any) => x.link === newsId);
          if (currentArticleIndex >= 0) {
            removed = data.articles.splice(currentArticleIndex + 1);
            if (currentArticleIndex > 0) {
              val = data.articles.slice(0, currentArticleIndex).concat(removed);
            } else {
              val = removed;
            }
          } else {
            val = data.articles.splice(0, 4);
          }
        }
        return val;
      }),
      map((news) => news)
    );
    this.news$.pipe(take(1)).subscribe(() => {
      if (!(this.cdr as ViewRef).destroyed) {
        this.cdr.detectChanges();
      }
    });
  }

  pageChange(page: any) {
    this.payload.currentPage = page;
    this.getNewsSvc();
  }

  updatePaginationModel(result: any) {
    this.PaginationModel = {
      currentPage: result.pagination.page,
      pageSize: result.pagination.count,
      sort: null,
      totalPages: result.pagination.totalPages,
      totalResults: result.pagination.totalCount,
    };
  }

  ngOnDestroy() {
    if (this.newsListSubscription) {
      this.newsListSubscription.unsubscribe();
    }
    if (this.reloadLanguageForNewsCategoryName$) {
      this.reloadLanguageForNewsCategoryName$.unsubscribe();
    }
  }
}
